import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

const Block = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  min-height: 250px;
  font-size: 24px;
  font-weight: 400;

  div.right {
    text-align: right;
  }

  div {
    width: 50%;

    img {
      max-width: 400px;
      margin: 0 auto;
    }
  }

  ${maxMediaQueries.tablet`
    font-size: 18px;

    div.image {
      width: 33%;
    }

    div.image.left > img {
      display: none;
    }

    div.text {
      width: 66%;
    }

  `};

  ${maxMediaQueries.phone`
    font-size: 16px;
    flex-direction: ${props => (props.reverseOnPhone ? 'column-reverse' : 'column')};

    div.right {
      text-align: left;
    }

    div.text {
      width: 100%;
    }
    div.image {
      width: 100%;
      margin: 0 auto 20px auto;
    }

    img {
      display: block;
      width: 70%;
    }

    div.image.left > img{
      display: block;
    }
  `};
`;

export default Block;
